import React from 'react';

/* Единые тип/цвет/иконка файла по расширению — для уроков, материалов и админки. */

export const extOf = (name) => (String(name || '').split('.').pop() || '').toLowerCase();

// расширение → категория
const CAT = {};
const add = (cat, list) => list.forEach(e => { CAT[e] = cat; });
add('pdf', ['pdf']);
add('text', ['doc', 'docx', 'odt', 'rtf', 'txt', 'pages']);
add('sheet', ['xls', 'xlsx', 'ods', 'csv', 'numbers']);
add('slides', ['ppt', 'pptx', 'odp', 'key']);
add('archive', ['zip', 'rar', '7z', 'gz', 'tar']);
add('image', ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'bmp', 'heic']);
add('video', ['mp4', 'mov', 'webm', 'avi', 'mkv', 'm4v']);
add('audio', ['mp3', 'wav', 'ogg', 'm4a', 'flac', 'aac']);

const COLORS = {
  pdf:     ['rgba(210,59,59,0.14)', '#d23b3b'],
  text:    ['rgba(37,99,235,0.14)', '#2563eb'],
  sheet:   ['rgba(22,163,74,0.14)', '#16a34a'],
  slides:  ['rgba(217,119,6,0.16)', '#d97706'],
  archive: ['rgba(100,116,139,0.18)', '#64748b'],
  image:   ['rgba(8,145,178,0.15)', '#0891b2'],
  video:   ['rgba(124,58,237,0.16)', '#7c3aed'],
  audio:   ['rgba(219,39,119,0.14)', '#db2777'],
};
const LABEL = {
  pdf: 'PDF', text: 'Документ', sheet: 'Таблица', slides: 'Презентация',
  archive: 'Архив', image: 'Изображение', video: 'Видео', audio: 'Аудио',
};

export const fileCat = (name) => CAT[extOf(name)] || 'file';
export const fileColor = (name) => COLORS[fileCat(name)] || ['rgba(124,77,255,0.13)', 'var(--primary)'];

export const fmtSize = (b) => {
  if (!b || b <= 0) return null;
  const u = ['Б', 'КБ', 'МБ', 'ГБ']; let n = b, i = 0;
  while (n >= 1024 && i < u.length - 1) { n /= 1024; i++; }
  return `${(i === 0 ? n : n.toFixed(1)).toString().replace('.', ',')} ${u[i]}`;
};

export const fileMeta = (m, name) => {
  const label = LABEL[fileCat(name)] || (extOf(name) ? extOf(name).toUpperCase() : 'Файл');
  const size = fmtSize(m && m.size);
  return size ? `${label} · ${size}` : label;
};

export function FileIcon({ name, size = 22 }) {
  const p = { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' };
  switch (fileCat(name)) {
    case 'archive': // как у zip — папка с «молнией»
      return <svg {...p}><path d="M22 13V7a2 2 0 0 0-2-2h-8l-2-2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7" /><rect x="14" y="13" width="3" height="7" rx="1.4" /></svg>;
    case 'image':
      return <svg {...p}><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><polyline points="21 15 16 10 5 21" /></svg>;
    case 'video':
      return <svg {...p}><rect x="2" y="4" width="20" height="16" rx="3" /><polygon points="10 9 16 12 10 15 10 9" fill="currentColor" stroke="none" /></svg>;
    case 'audio':
      return <svg {...p}><path d="M9 18V5l12-2v13" /><circle cx="6" cy="18" r="3" /><circle cx="18" cy="16" r="3" /></svg>;
    case 'sheet': // сетка-таблица
      return <svg {...p}><rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="3" y1="15" x2="21" y2="15" /><line x1="9" y1="3" x2="9" y2="21" /><line x1="15" y1="3" x2="15" y2="21" /></svg>;
    case 'slides': // экран-презентация
      return <svg {...p}><rect x="2" y="3" width="20" height="14" rx="2" /><line x1="12" y1="17" x2="12" y2="21" /><line x1="8" y1="21" x2="16" y2="21" /></svg>;
    case 'pdf': // лист с «плашкой» снизу
      return <svg {...p}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><rect x="7.5" y="13" width="9" height="5" rx="1.2" /></svg>;
    case 'text': // лист со строками текста
      return <svg {...p}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="8" y1="13" x2="16" y2="13" /><line x1="8" y1="17" x2="13" y2="17" /></svg>;
    default:
      return <svg {...p}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>;
  }
}
